import React, { forwardRef } from 'react'
import { PropTypes } from 'prop-types'
import DataConfirmation from '../DataConfirmation'
import ContainerFields from './ContainerFields'

const Confirmation = forwardRef((props, ref) => {
  const { quotation, proposal, quotationStatus } = props
  return (
    <>
      <DataConfirmation
        ref={ref}
        {...props}
      >
        <ContainerFields
          quotation={quotation}
          proposal={proposal}
          quotationStatus={quotationStatus}
        />
      </DataConfirmation>
    </>
  )
})

Confirmation.propTypes = {
  proposal: PropTypes.any,
  quotation: PropTypes.any.isRequired,
  quotationStatus: PropTypes.any.isRequired,
}

Confirmation.defaultProps = {
  proposal: {},
}

export default Confirmation
